import { Typography } from "@mui/material";

const PrivacyPolicyInfo = () => (
  <Typography>
    <span>個人情報保護の内容をご確認していない方は</span>
    <a
      target="_blank"
      rel="noreferrer noopener"
      href="https://nishinihonfactor-plus.jp/privacy-policy/"
    >こちらのリンク</a>
    <span>からご確認をお願いします</span>
  </Typography>
);

export default PrivacyPolicyInfo;
